import { render, staticRenderFns } from "./FormCreateCampaignRedeemCoin.vue?vue&type=template&id=79c54852&"
import script from "./FormCreateCampaignRedeemCoin.vue?vue&type=script&lang=js&"
export * from "./FormCreateCampaignRedeemCoin.vue?vue&type=script&lang=js&"
import style0 from "./FormCreateCampaignRedeemCoin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports